export default "__VITE_ASSET__VLr7nfkZ__"